var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":"","pt-4":""}},[_c('v-img',{attrs:{"src":"//assets.office4u.xyz/common_asset/coming-soon.png"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }